export default __webpack_public_path__ + "static/media/06-buy a house.1706a35e.svg";